import ClickAwayListener from "react-click-away-listener";
import { useState } from 'react';
import Music from 'scripts/music';

function AudioMenu() {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [musicMuted, setMusicMuted] = useState<boolean>(true);
    const [volume, setVolume] = useState<number>(0.0);

    const onVolumeChange = (newVolume: string) => {
        const volumeValue = parseFloat(newVolume);
        setVolume(volumeValue);
        setMusicMuted(volumeValue === 0.0);
        Music.instance.setVolume(volumeValue);
    }

    const handleButtonClick = (e: any) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    }

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <div id="audio-menu-component">
                <div id="audio-slider" className={!isOpen ? 'hidden' : ''}>
                    <input
                        type="range"
                        value={volume}
                        min="0.0"
                        max="1.0"
                        step="0.05"
                        onChange={(e: any) => onVolumeChange(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                <div className="circle-button" onClick={handleButtonClick}>
                    <svg>
                        <use href={musicMuted || volume === 0.0 ? '#muted' : '#unmuted'}/>
                    </svg>
                </div>
            </div>
        </ClickAwayListener>
    );
}

export default AudioMenu;
